
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Sprawdzenie czy mamy dostęp do elementów nawigacji
import { getNavItems, getCompleteNavItems } from './data/navItems';
import { NavItem } from './types/navigation';

// Deklaracja dla window._navItemsBackup
declare global {
  interface Window {
    _navItemsBackup?: NavItem[];
  }
}

// Inicjalizacja i sprawdzenie struktury nawigacji przy starcie aplikacji
const navItems = getCompleteNavItems();
console.log('Inicjalizacja nawigacji w main.tsx:', navItems);
console.log('Blog jest obecny w nawigacji:', navItems.some(item => item.href === '/blog'));

// Utwórz kopię zapasową elementów nawigacji w window
window._navItemsBackup = [...navItems];

// Funkcja pomocnicza do weryfikacji struktury nawigacji
const verifyNavigation = () => {
  if (typeof window !== 'undefined') {
    // Sprawdź nawigację po pełnym załadowaniu DOM
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM załadowany - sprawdzam nawigację:');
      const navItems = getCompleteNavItems();
      console.log('Elementy nawigacji po załadowaniu DOM:', navItems);
      console.log('Blog obecny w nawigacji po załadowaniu:', navItems.some(item => item.href === '/blog'));
      
      // Aktualizuj kopię zapasową
      window._navItemsBackup = [...navItems];
    });
  }
};

// Wywołanie funkcji weryfikującej
verifyNavigation();

// Usuwamy potencjalne widgety Lovable, jak wcześniej
document.addEventListener('DOMContentLoaded', () => {
  // Select and remove any Lovable widgets if they exist
  const lovableElements = document.querySelectorAll('[id*="lovable-"], [class*="lovable-"]');
  lovableElements.forEach(element => element.remove());
  
  // Also hide via style for any dynamically added elements
  const style = document.createElement('style');
  style.innerHTML = `
    [id*="lovable-"], [class*="lovable-"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
});

createRoot(document.getElementById("root")!).render(<App />);
